import { SET_APPLICATION_NAME, SET_APP_DATA, SET_MSAL_CONFIG_DATA } from '.';
import { encrypt } from '../../utils/LocalStorage';
import {
  SetAppDataAction,
  SetAppDataParams,
  SetApplicationNameAction,
  SetApplicationNameParams,
  SetMSALConfigAction,
  SetMSALConfigParams,
} from '../mappers/AppTypesMapper';

export const setAppData = (
  dispatch: (action: SetAppDataAction) => void,
  param: SetAppDataParams
): void => {
  dispatch({
    type: SET_APP_DATA,
    payload: param,
  });
};

export const setApplicationName = (
  dispatch: (action: SetApplicationNameAction) => void,
  param: SetApplicationNameParams
): void => {
  localStorage.setItem('applicationName', param.applicationName ?? '');
  dispatch({
    type: SET_APPLICATION_NAME,
    payload: { applicationName: param.applicationName },
  });
};

export const setMsalConfigData = (
  dispatch: (payload: SetMSALConfigAction) => void,
  param: SetMSALConfigParams
): void => {
  localStorage.setItem('authConfig', encrypt(JSON.stringify(param?.authConfig)));
  dispatch({
    type: SET_MSAL_CONFIG_DATA,
    payload: { authConfig: param?.authConfig },
  });
};
